// frontend/src/hooks/useMediaQuery.ts
import { useCallback, useMemo, useSyncExternalStore } from 'react';

/**
 * Live `matchMedia` state. Use it to render ONE layout instead of CSS-hiding
 * the other: a `hidden` subtree still mounts, fetches, and runs its effects.
 */
export function useMediaQuery(query: string): boolean {
  const media = useMemo(() => window.matchMedia(query), [query]);
  const subscribe = useCallback((onChange: () => void) => {
    media.addEventListener('change', onChange);
    return () => media.removeEventListener('change', onChange);
  }, [media]);
  return useSyncExternalStore(subscribe, () => media.matches, () => false);
}
